var _rect, _rect2, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpcomingFeteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    fill: "url(#a)",
    rx: 19.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    stroke: "#EAECF0",
    rx: 19.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 24,
    height: 24,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 8H8v24h24V8Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "evenodd",
    d: "m16.076 15.26.095.083 8.486 8.485a.996.996 0 0 1 .106 1.291 1.002 1.002 0 0 1-.352.304l-.116.05L13.91 29.3c-1.952.72-3.853-1.115-3.26-3.064l.05-.146 3.826-10.385a.995.995 0 0 1 .603-.597 1.002 1.002 0 0 1 .844.081l.103.071Zm-.214 2.602-3.285 8.92a.499.499 0 0 0 .562.664l.08-.023 8.918-3.286-6.275-6.275Zm9.245 1.742c.91.048 2.16.24 3.246.892a.999.999 0 0 1-.185 1.806c-.242.083-.507.07-.74-.036l-.104-.055c-.682-.41-1.554-.57-2.322-.61a7.72 7.72 0 0 0-.95.004l-.316.031a1 1 0 0 1-.281-1.98 8.594 8.594 0 0 1 1.652-.053m2.025-2.786a.998.998 0 0 1 .996.942 1.002 1.002 0 0 1-.88 1.051l-.116.007h-.708a1 1 0 0 1-.116-1.993l.116-.007h.708Zm-3.182-.767a.998.998 0 0 1 .083 1.32l-.083.094-1.06 1.061a.999.999 0 0 1-1.498-1.32l.083-.094 1.06-1.06a1.003 1.003 0 0 1 1.415 0Zm-2.587-5.265c.448 1.346.208 2.82-.072 3.85-.168.642-.4 1.266-.69 1.863a1 1 0 1 1-1.79-.893c.232-.48.416-.98.55-1.496.227-.832.34-1.735.166-2.475l-.061-.216a1 1 0 1 1 1.897-.633Zm5.415 2.438a1 1 0 0 1 0 1.414l-.707.707a.992.992 0 0 1-.71.306 1.004 1.004 0 0 1-.935-.622.998.998 0 0 1 .23-1.098l.708-.707a1 1 0 0 1 1.414 0Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 20,
    x2: 20,
    y1: 0,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EBEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 28.843,
    x2: 6.725,
    y1: 10.089,
    y2: 16.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingFeteIcon);
export default __webpack_public_path__ + "static/media/upcoming-fete-icon.1878d7d1c153b230c385985cf777ade4.svg";
export { ForwardRef as ReactComponent };